import './ifit-features.component.scss'

import { Swiper } from 'swiper'

document.querySelectorAll('.ifit-features__slider').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        768: {
          slidesPerView: 2
        }
      }
    })
  }
})
